import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

// project imports
import { getDynamicDashboardPath } from 'config';
import Logo from 'ui-component/Logo';

import GlobalStatusIndicator from './GlobalStatusIndicator';
import TemplateWatcherSyncIndicator from './TemplateWatcherSyncIndicator';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection() {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        minHeight: 36,
      }}
    >
      <Link
        component={RouterLink}
        to={getDynamicDashboardPath()}
        aria-label="theme-logo"
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Logo />
      </Link>
      <TemplateWatcherSyncIndicator />
      <GlobalStatusIndicator />
    </Box>
  );
}
